/**
 * O portao de confirmacao (ADR-0003).
 *
 * Isto e o unico lugar do aplicativo onde uma acao proposta pela IA pode passar
 * a escrita — e so passa com um toque em "Confirmar". Nunca aparece JSON: a
 * pessoa le uma frase em portugues, "Vou registrar uma despesa de R$ 43,20 no
 * Supermercado, hoje. Confirma?", e decide.
 *
 * Confianca alta NAO dispensa a confirmacao. Um modelo confiante e errado e
 * exatamente o caso perigoso.
 */
import { BigButton, Card, Stack } from '@flos/ui';
import type { AiAction } from '@flos/shared';

export interface ProposalCardProps {
  action: AiAction;
  busy?: boolean;
  onConfirm: () => void;
  onCorrect: () => void;
  onCancel: () => void;
}

export function ProposalCard({
  action,
  busy = false,
  onConfirm,
  onCorrect,
  onCancel,
}: ProposalCardProps) {
  return (
    <Card tone="neutral" title="Confirma?">
      <Stack gap="lg">
        <p className="app-proposal__summary" data-testid="proposta-resumo">
          {action.summary}
        </p>

        <Stack gap="sm">
          <BigButton
            size="xl"
            icon="✅"
            fullWidth
            loading={busy}
            onClick={onConfirm}
            data-testid="confirmar"
          >
            Confirmar
          </BigButton>
          <BigButton
            size="lg"
            variant="secondary"
            icon="✏️"
            fullWidth
            disabled={busy}
            onClick={onCorrect}
          >
            Corrigir
          </BigButton>
          <BigButton
            size="lg"
            variant="ghost"
            icon="✖️"
            fullWidth
            disabled={busy}
            onClick={onCancel}
          >
            Cancelar
          </BigButton>
        </Stack>
      </Stack>
    </Card>
  );
}
